import '../../scss/app.scss';
import BundleProps from "./Components/BundleProps";

// You may want to change this name to the ww-your-widget-name (remeber to also change it in the twig file)
Vue.component('ww-bundle-props', BundleProps);
